export interface Tenant {
  id: string;
  name: string;
  createdAt: number;
}

export interface Product {
  id: string;
  name: string;
  tiers: string[];
}

export interface HealthResponse {
  ok: boolean;
  version: string;
  uptimeMs: number;
}

// GET /api/me response shape — see keyforge/src/kf_handler_me.sk
export interface MeResponse {
  tenantId: string;
  userId: string;
  role: number;
  expiresAtMs: number;
}

// GET /api/audit response shape — see keyforge/src/kf_handler_audit_list.sk
export interface AuditEntry {
  ts: number;
  kind: number;
  outcome: number;
  tenant: string;
  actor: string;
  target: string;
  detail_len: number;
}

const KF_BASE = (import.meta as unknown as { env: { VITE_KF_URL?: string } }).env.VITE_KF_URL ?? '/api';

import { fetchWithAuth } from './auth';

async function kfFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetchWithAuth(`${KF_BASE}${path}`, {
    ...init,
    headers: { 'accept': 'application/json', ...(init?.headers ?? {}) },
  });
  if (!res.ok) {
    throw new Error(`KF ${path}: ${res.status} ${res.statusText}`);
  }
  return res.json() as Promise<T>;
}

export const kfClient = {
  health: () => kfFetch<HealthResponse>('/health'),
  listTenants: () => kfFetch<{ tenants: Tenant[] }>('/tenants'),
  listProducts: () => kfFetch<{ products: Product[] }>('/products'),
  productTiers: (productId: string) =>
    kfFetch<{ tiers: string[] }>(`/products/${encodeURIComponent(productId)}/tiers`),
  me: () => kfFetch<MeResponse>('/me'),
  auditList: (limit: number = 100) =>
    kfFetch<{ entries: AuditEntry[] }>(`/audit?limit=${limit}`),
};
